export default class OrderShipperMessage {
  constructor (options = {}) {
    this.model = 'OrderShipperMessage'

    this.id = options.id
    this.order_id = options.order_id
    this.shipper_id = options.shipper_id
    this.receiver_id = options.receiver_id

    // Message
    this.message = options.message
    this.is_confirmed = options.is_confirmed

    // Auditing
    this.added_by = options.added_by
    this.confirmed_by = options.confirmed_by
    this.confirmed_at = options.confirmed_at
    this.created_at = options.created_at
    this.updated_at = options.updated_at

    // Associations
    if (options.order) this.order = options.order
    if (options.shipper) this.shipper = options.shipper
    if (options.receiver) this.receiver = options.receiver
  }
}
